import React from 'react';
import cx from 'classnames';

class SignIn extends React.Component {
  render() {
    const { styles: s } = this.props;

    return (
      <div>
        <section className={s.agencyBannerArea}>
          <div className={s.bubble}>
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <div className={s.agencyBanner}>
            <div className={s.devider}>
              <svg
                className={cx(s.uncodeRowDivider, s.uncodeRowDividerCurve)}
                x="0px"
                y="0px"
                width="240px"
                height="24px"
                viewBox="0 0 240 24"
                enableBackground="new 0 0 240 24"
                xmlSpace="preserve"
                preserveAspectRatio="none"
              >
                <path
                  fill="#ffffff"
                  d="M0,24l0.01-0.24V0H240v24c0,0-48.115-23.471-120.039-23.48C48.018,0.52,0,24,0,24L0,24z"
                />
              </svg>
            </div>
          </div>
          {this.props.children}
        </section>
      </div>
    );
  }
}

export default SignIn;



// WEBPACK FOOTER //
// ./src/routes/legal/cookiePolicy/BannerArea.js